import { ShoppingProcessType } from "InitialData/constant";
import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import reciveImg from "resources/img/puffu/reviceImg.png";
import reciveImg2 from "resources/img/puffu/reciveImg2.png";
import loadingImg from "resources/img/puffuLoadingImg.svg"
import serveProduct from "resources/img/serveProduct.svg"
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import thankyouSound from "resources/music/audio_2_감사합니다__결제가_완료되었습니다_.mp3";

function DemoReceiveItemStep() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setViewData } = useOutletContext();
    const audioRef = useRef();
  
    // 상태 정의
    const [status, setStatus] = useState('CHECKING'); // CHECKING, WAITING_OTHER, WAITING_CURRENT, COMPLETED
    const [isInitialized, setIsInitialized] = useState(false);
    
  
    // Redux 상태 가져오기
    const { isRailActive, deviceCode } = useSelector((state) => ({
      isRailActive: state.history.isRailActive,
      deviceCode: state.history.deviceCode
    }));
  
    const currentDeviceCode = window.BRIDGE?.getDeviceCode?.();
  
    // 초기 상태 설정 및 레일 상태 체크
    useEffect(() => {
      if (!isInitialized && currentDeviceCode) {
        initializeRailStatus();
        setIsInitialized(true);
      }
    }, [currentDeviceCode, isInitialized]);
  
    const initializeRailStatus = () => {
      if (!isRailActive) {
        // 레일이 비활성화 상태면 현재 기기로 활성화
        activateRail();
      } else if (deviceCode !== currentDeviceCode) {
        // 다른 기기가 사용 중이면 대기
        setStatus('WAITING_OTHER');
      } else {
        // 현재 기기가 이미 사용 중이면 계속 대기
        setStatus('WAITING_CURRENT');
      }
    };
  
    const activateRail = () => {
      if (!currentDeviceCode) return;
  
      dispatch(HistoryReducer.actions.setIsRailActive({
        isRailActive: true,
        deviceCode: currentDeviceCode
      }));
  
      const data = {
        code: "isRailActivated",
        roomId: id,
        deviceCode: currentDeviceCode
      };
  
      // requester.testOrder(data)
      //     .then(() => {
      //         setStatus('WAITING_CURRENT');
      //     })
      //     .catch((error) => {
      //         console.error('Error activating rail:', error);
      //         setStatus('CHECKING');
      //     });

      
  
      requester.testOrder(data, (result) => {
        if (result.code == 0) {
          setStatus('WAITING_CURRENT');
        } else {
          setStatus('CHECKING');
        }
      })
    };
  
    // 레일 상태 변경 감지
    useEffect(() => {
      if (!isRailActive && isInitialized) {
        handleRailStateChange();
      }
    }, [isRailActive, status, isInitialized]);
  
    const handleRailStateChange = () => {
      switch (status) {
        case 'WAITING_OTHER':
          // 다른 기기 작동이 끝나면 현재 기기로 전환
          activateRail();
          break;
        case 'WAITING_CURRENT':
          // 현재 기기 작동이 끝나면 완료 상태로
          completeProcess();
          break;
        default:
          break;
      }
    };
  
    const completeProcess = () => {
      setStatus('COMPLETED');
      playAudio();
  
      // Rail 완료 상태 전파
      const data = {
        code: "isRailCompleted",
        roomId: id,
        deviceCode: currentDeviceCode
      };
      requester.testOrder(data, (result) => {
      })
    };
  
    // 완료 상태에서 메인 화면으로 이동
    useEffect(() => {
      let timer;
      if (status === 'COMPLETED') {
        timer = setTimeout(() => {
          // navigate(`/ws/${id}/horizontal2/home2`);
          navigate(`/ws/${id}/home`);
        }, 5000);
      }
      return () => timer && clearTimeout(timer);
    }, [status, id]);
  
    // 초기화 및 정리
    useEffect(() => {
      const initData = {
        title: "",
        footterButtonText: "",
        currentProcess: ShoppingProcessType.ORDER_COMPLETE,
        totalCount: 0,
        selectedCount: 0,
        priceSum: 0,
        vat: 0,
        deliveryFee: 0,
        discountSum: 0,
        totalAmount: 0,
        onDeleteSelectedProductsClick: () => { },
        onSubmitButtonClick: () => { },
        detailYn: false,
        detailProduct: null
      };
      setViewData(initData);
  
      if (currentDeviceCode) {
        const cartData = {
          roomId: id,
          code: "clearCartProducts",
          deviceCode: currentDeviceCode
        };
        requester.testOrder(cartData, (result) => {
        })
      }
  
      return () => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
  
        // 컴포넌트 언마운트 시 레일 상태 초기화
        if (status !== 'COMPLETED' && currentDeviceCode === deviceCode) {
          dispatch(HistoryReducer.actions.setIsRailActive({
            isRailActive: false,
            deviceCode: null
          }));
        }
      };
    }, []);
  
    const playAudio = async () => {
      try {
        if (audioRef.current) {
          audioRef.current.currentTime = 0;
          audioRef.current.volume = 1.0;
          await audioRef.current.play();
        }
      } catch (error) {
        console.error('Error playing audio:', error);
      }
    };
  
    const messageStyle = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: "870px",
      fontSize: '24px',
      fontWeight: 'bold',
      color: 'var(--main-color)'
    };
  
  
    // MainContent 컴포넌트
    const MainContent = ({ audioRef, isRailActive, deviceCode }) => (
      <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
        <audio ref={audioRef} src={thankyouSound} preload="auto" />
        <Dummy height={"35px"} />
        <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "95.7%", height: "870px" }}>
          <VerticalFlex gap={50}>
            <FlexChild height={"max-content"}>
              <Center>
                <P weight={700} size={32}>결제가 완료되었습니다.</P>
                <Dummy height={"15px"} />
                <P weight={500} size={25}>구매해주셔서 감사합니다.</P>
              </Center>
            </FlexChild>
            <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
            <FlexChild height={"max-content"}>
              <Center>
                <P size={32} weight={700} color={"var(--main-color)"}>토출구에서 물건을 가져가세요!</P>
              </Center>
            </FlexChild>
            <FlexChild>
              <img src={reciveImg} width={"700px"} alt="받기 이미지" />
            </FlexChild>
          </VerticalFlex>
        </div>
  
      </div>
    );
  
    // AnotherRailActivatedContent 컴포넌트
    const AnotherRailActivatedContent = ({ audioRef, isRailActive, deviceCode }) => (
      <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
        {/* <audio ref={audioRef} src={thankyouSound} preload="auto" /> */}
        <Dummy height={"35px"} />
        <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "95.7%", height: "870px" }}>
          <VerticalFlex gap={50}>
            <FlexChild height={"max-content"}>
              <Center>
                <P weight={700} size={32}>결제가 완료되었습니다.</P>
                <Dummy height={"15px"} />
                <P weight={500} size={25}>구매해주셔서 감사합니다.</P>
              </Center>
            </FlexChild>
            <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
            <FlexChild height={"max-content"}>
              <Center>
                <P size={32} weight={700} color={"var(--main-color)"}>먼저 구매한 고객님이 물건을 수령 중이에요.</P>
                <P size={32} weight={700} color={"var(--main-color)"}>잠시만 기다려주세요.</P>
              </Center>
            </FlexChild>
            <FlexChild>
              <img src={reciveImg2} width={"700px"} alt="상품 준비중 이미지" />
            </FlexChild>
          </VerticalFlex>
        </div>
  
      </div>
    );

        // PaymentCompleteContent 컴포넌트
        const PaymentCompleteContent = ({ audioRef, isRailActive, deviceCode }) => (
          <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
            <Dummy height={"35px"} />
            <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "95.7%", height: "870px" }}>
              <VerticalFlex gap={25}>
                <FlexChild height={"max-content"}>
                  <Center>
                    <P weight={700} size={32}>결제가 완료되었습니다.</P>
                    <Dummy height={"15px"} />
                    <P weight={500} size={25}>구매해주셔서 감사합니다.</P>
                  </Center>
                </FlexChild>
                <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
                <FlexChild height={"max-content"}>
                  <Center>
                    <P size={32} weight={700} color={"var(--main-color)"}>푸푸가 고객님의 물건을 준비중이에요.</P>
                    <P size={32} weight={700} color={"var(--main-color)"}>잠시만 기다려주세요.</P>
                  </Center>
                </FlexChild>
                <FlexChild>
                  <img src={reciveImg2} width={"700px"} alt="상품 준비중 이미지" />
                </FlexChild>
              </VerticalFlex>
            </div>
      
          </div>
        );
  
    // 상태에 따른 렌더링
    const renderContent = () => {
      switch (status) {
        case 'CHECKING':
          return null;
        case 'WAITING_OTHER':
          // return (
          //     <div style={messageStyle}>
          //         현재 다른 기기로부터 레일이 작동중입니다.
  
          //     </div>
          // );
          return <AnotherRailActivatedContent audioRef={audioRef} isActive={isRailActive} deviceCode={deviceCode} />;
        case 'WAITING_CURRENT':
          // return (
          //   <div style={messageStyle}>
          //     상품을 준비중입니다 잠시만 기다려주세요..
          //   </div>
          // );
          return <PaymentCompleteContent audioRef={audioRef} isActive={isRailActive} deviceCode={deviceCode} />;
        case 'COMPLETED':
          return <MainContent audioRef={audioRef} isActive={isRailActive} deviceCode={deviceCode} />;
        default:
          return null;
      }
    };
  
    return renderContent();
  }

export default DemoReceiveItemStep;